export const FEATURE_NAME = 'regions';

export const LIST = 'list';
export const FILTERS = 'filters';

export const LEGAL_ENTITY = 'legalEntity';
export const IS_CANTON = 'isCanton';
